export const HELP_CENTER_ERROR_TYPE = {
  invalidProblem: '/errors/invalid-problem',
} as const

export type HelpCenterErrorType =
  (typeof HELP_CENTER_ERROR_TYPE)[keyof typeof HELP_CENTER_ERROR_TYPE]
